import { AlertType } from './types'

export const TypeSettings: {
  [key in AlertType]: {
    color: string
    backgroundColor: string
    icon: string
  }
} = {
  success: {
    color: 'text-notif-green',
    backgroundColor: 'bg-notif-green-01',
    icon: 'check'
  },
  warning: {
    color: 'text-notif-yellow',
    backgroundColor: 'bg-notif-yellow-01',
    icon: 'exclamation'
  },
  error: {
    color: 'text-notif-red',
    backgroundColor: 'bg-notif-red-01',
    icon: 'error'
  },
  info: {
    color: 'text-notif-blue',
    backgroundColor: 'bg-notif-blue-01',
    icon: 'info'
  },
  neutral: {
    color: 'text-notif-gray',
    backgroundColor: 'bg-notif-gray-01',
    icon: 'info'
  }
} as const
